module.exports = __webpack_public_path__ + "img/hago.f08689b.png";